module.exports = __webpack_public_path__ + "img/menu.c0518f0c.svg";